import Login from '../components/Pages/Login.vue';
import UpdatePassword from '../components/Pages/UpdatePassword.vue';

import Page401Unauthorized from '../components/Pages/PageUnauthorized401.vue';
import Page403Forbidden from '../components/Pages/PageForbidden403.vue';
import Page404NotFound from '../components/Pages/PageNotFound404.vue';

import PrivatePage from '../components/Pages/PrivatePage.vue';

import NewContract from '../components/Pages/NuevoContrato.vue';
import Contracts from '../components/Pages/Contratos.vue';
import NewContractStep1 from '../components/Pages/NewContract/Step1.vue';
import NewContractStep2 from '../components/Pages/NewContract/Step2.vue';
import NewContractStep3 from '../components/Pages/NewContract/Step3.vue';

import RenewContract from '../components/Pages/RenovarContrato.vue';
import RenewContractStep1 from '../components/Pages/RenewContract/Step1.vue';
import RenewContractStep2 from '../components/Pages/RenewContract/Step2.vue';
import RenewContractStep3 from '../components/Pages/RenewContract/Step3.vue';

import Products from '../components/Pages/Productos.vue';
import Clients from '../components/Pages/Clientes.vue';
import BlackList from '../components/Pages/BlackList.vue';
import Statistics from '../components/Pages/Estadisticas.vue';
import GestionUsuarios from '../components/Pages/GestionUsuarios.vue';
import Cancellations from '../components/Pages/Cancellations.vue';
import CambiarContrasena from '../components/Pages/CambiarContrasena.vue';
import ResetearContrasena from '../components/Pages/ResetearContrasena.vue';
import ObtenerOTP from '../components/Pages/ObtenerOTP.vue';
import Promociones from "../components/Pages/Promociones.vue";
import Renews from '../components/Pages/Renews.vue';

import Risks from '../components/Pages/Riesgos.vue';
import NewPromotion from '../components/Pages/NuevaPromocion.vue';
import NewPromotionStep1 from '../components/Pages/NewPromotion/Step1.vue';
import NewPromotionStep2 from '../components/Pages/NewPromotion/Step2.vue';

import FeedBackBR from "../components/Pages/FeedbackBr.vue"


import Issues from '../components/Pages/Incidencias.vue';
import GestionEstados from '../components/Pages/GestionEstados.vue';
import OperacionesCSV from '../components/Pages/OperacionesCSV.vue';

const routes = [
  {
    path: "/",
    name: "home",
    component: Login
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/getOtp",
    name: "getOtp",
    component: ObtenerOTP
  },
  {
    path: "/resetPassword",
    name: "resetPassword",
    component: ResetearContrasena
  },
  {
    path: "/update-password",
    name: "updatePassword",
    component: UpdatePassword
  },
  {
    path: "/contracts",
    name: "contratos",
    component: Contracts,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin"
      ]
    }
  },
  {
    path: "/contracts/new-contract",
    component: NewContract,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin"
      ]
    },
    children: [
      {
        path: "select-product",
        name: "newContractStep1",
        component: NewContractStep1
      },
      {
        path: "client-data",
        name: "newContractStep2",
        component: NewContractStep2
      },
      {
        path: "summary",
        name: "newContractStep3",
        component: NewContractStep3
      }
    ]
  },
  {
    path: "/contracts/renew-contract",
    component: RenewContract,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin"
      ]
    },
    children: [
      {
        path: "select-product",
        name: "renewContractStep1",
        component: RenewContractStep1
      },
      {
        path: "client-data",
        name: "renewContractStep2",
        component: RenewContractStep2
      },
      {
        path: "summary",
        name: "renewContractStep3",
        component: RenewContractStep3
      }
    ]
  },
  {
    path: "/products",
    name: "productos",
    component: Products,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin"
      ]
    }
  },
  {
    path: "/clients",
    name: "clientes",
    component: Clients,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin"
      ]
    }
  },
  {
    path: "/stats",
    name: "estadisticas",
    component: Statistics,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "Backoffice_supervisor",
      ]
    }
  },
  {
    path: "/black-list",
    name: "blackList",
    component: BlackList,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "Backoffice_Superadmin"
      ]
    }
  },
  {
    path: "/cancellations",
    name: "cancelaciones",
    component: Cancellations,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: ["Backoffice_member"]
    }
  },
  {
    path: "/401",
    name: "page-unauthorized",
    component: Page401Unauthorized,
    meta: {
      layout: "AppLayoutDefault"
    }
  },
  {
    path: "/403",
    name: "page-forbidden",
    component: Page403Forbidden,
    meta: {
      layout: "AppLayoutPrivate"
    }
  },
  {
    path: "/:pathMatch(.*)*",
    component: Page404NotFound,
    meta: {
      layout: "AppLayoutPrivate"
    }
  },
  {
    path: "/private-page",
    name: "private-page",
    component: PrivatePage,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_admin"
      ]
    }
  },
  {
    path: "/risks",
    name: "riesgos",
    component: Risks,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: ["Backoffice_supervisor"]
    }
  },
  {
    path: "/change-password",
    name: "change-password",
    component: CambiarContrasena,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin"
      ]
    }
  },
  {
    path: "/user-manage",
    name: "gestionUsuarios",
    component: GestionUsuarios,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: ["Backoffice_supervisor", "Backoffice_member", "Backoffice_admin"]
    }
  },
  {
    path: "/renews",
    name: "renovaciones",
    component: Renews,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin"
      ]
    }
  },
  {
    path: "/promotions",
    name: "promociones",
    component: Promociones,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_admin"
      ]
    }
  },
  {
    path: "/promotions/new-promotion",
    component: NewPromotion,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin"
      ]
    },
    children: [
      {
        path: "promotion-data",
        name: "newPromotionStep1",
        component: NewPromotionStep1
      },
      {
        path: "summary",
        name: "newPromotionStep2",
        component: NewPromotionStep2
      }
    ]
  },
  {
    path: "/issues",
    name: "incidencias",
    component: Issues,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "sinRol",
        "admin",
        "super-admin",
        "Backoffice_supervisor",
        "Backoffice_member",
        "Backoffice_member_empresas",
        "Backoffice_admin",
      ]
    }
  },
  {
    path: "/bankreader/callback",
    name: "feedBackBR",
    component: FeedBackBR
  },
  {
    path: "/state-management",
    name: "gestionEstados",
    component: GestionEstados,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "Backoffice_supervisor",
        "Backoffice_admin",
        "Backoffice_Superadmin"
      ]
    }
  },
  {
    path: "/csv-operations",
    name: "operacionesCSV",
    component: OperacionesCSV,
    meta: {
      layout: "AppLayoutPrivate",
      requiresAuth: true,
      roles: [
        "Backoffice_supervisor",
        "Backoffice_admin",
        "Backoffice_Superadmin"
      ]
    }
  }
]

export default routes;